import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { TimelineService } from './services/timeline.service';

export function provideOutlookTimelineDataAccess(): EnvironmentProviders {
  return makeEnvironmentProviders([TimelineService]);
}
